// remove html title labels from attributes
function removeTitles() {
    const labels = document.querySelectorAll('.sk-attr .sk-label label');
    if (labels.length > 0) {
        labels.forEach((label) => {
            if (label.getAttribute("title")) {
                label.setAttribute("title", "")
            }
        })
    }
}

export { removeTitles };